module.exports = __webpack_public_path__ + "3c790596a0a8f98e4b48b11fa50022b0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/screenshot.png
// module id = hQ5U
// module chunks = 0